const TEXT = {
  PHONE_USAGE: 'We will use this telephone number in the event of any problems with delivery.',
  BACK_TO_STOCK: 'We will use this number to notify the user when the size will be back in stock.',
};

export default TEXT;
